import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../auth/auth.service';

export const claimsGuard: CanActivateFn = async (route, state) => {
    const authService = inject(AuthService);
    const router = inject(Router);

    const requiredClaims: string[] = route.data['claims'] || [];
    const requiredClaimPrefixes: string[] = route.data['claimPrefixes'] || [];

    const user = await authService.returnUserInfo();

    if (!user) {
        return router.createUrlTree(['/login']);
    }

    // Superadmin tiene acceso a todo
    if (Number((user as any)?.superadmin) === 1) return true;

    const userClaims = user.claims?.map((c) => c.nombre) ?? [];

    // ✅ “Tiene alguno de los permisos”
    const hasClaim = requiredClaims.length === 0 || requiredClaims.some((c) => userClaims.includes(c));
    const hasClaimPrefix =
        requiredClaimPrefixes.length === 0 || requiredClaimPrefixes.some((prefix) => userClaims.some((uc) => uc.startsWith(prefix)));

    if (hasClaim && hasClaimPrefix) return true;

    console.warn('Acceso denegado. Faltan claims requeridos:', { requiredClaims, requiredClaimPrefixes });
    return router.createUrlTree(['/acceso-denegado'], {
        queryParams: {
            back: state.url,
            modulo: route.data['moduleName'] || ''
        }
    });
};
